var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34.365,
    viewBox: "0 0 41.659 34.365",
    width: 41.659,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.574.737a.9.9 0 0 0 -.606-.66 3.141 3.141 0 0 0 -1.638.123s-36.5 13.113-38.587 14.568c-.448.314-.6.495-.672.706-.361 1.033.762 1.493.762 1.493l9.406 3.065.085.01 4.409 12.2a2.846 2.846 0 0 0 .927 1.12.061.061 0 0 0 .028.016.96.96 0 0 0 .113.038.514.514 0 0 0 .115.012c.37 0 .963-.314 1.918-1.269 2.015-2.015 3.968-3.7 4.945-4.522 3.234 2.232 6.714 4.7 8.216 6a2.616 2.616 0 0 0 1.906.734 2.146 2.146 0 0 0 1.823-1.618s6.654-26.779 6.876-30.365c.019-.354.05-.578.054-.818a3.013 3.013 0 0 0 -.082-.833m-25.224 21.927a.85.85 0 0 0 -.109.174.371.371 0 0 0 -.028.128l-.554 5.877-2.966-10.088c5.509-3.477 19.722-12.411 20.676-12.755.177-.056.306 0 .271.125-.448 1.573-17.29 16.544-17.29 16.544",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.7a2c0e9ae878eb35771703a3c8130570.svg";
export { ForwardRef as ReactComponent };